import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancelled">
        <XCircle className="w-14 h-14 text-white/30 mx-auto mb-6" />
        <h1 className="text-white text-2xl font-semibold mb-3">Payment cancelled</h1>
        <p className="text-white/50 text-sm mb-8">No charge was made. Your estimate is saved — you can pay anytime from the invoice in your email.</p>
        <button onClick={() => navigate('/')} className="px-8 py-4 bg-gold text-black font-bold uppercase tracking-wide hover:bg-[#E5B954] transition-colors">Back to Home</button>
      </div>
    </div>
  );
}
